<!--use a s sample to build out new route/child route logic-->
<template>
    <v-main v-if="org" >
        <v-card outlined>
            <v-card-title>
                {{org.info.fullname}} {{$route.name}}
            </v-card-title>
            <v-container>
                <v-row v-if="org.userpool">
                    <v-col :cols="count" v-for="t in tiles"   :key="t.to">
                        <v-card  :to="t.to" outlined height="70" :dark="t.name===$route.name" >
                            <v-card-text>
                                <div class="text-center">
                                    <v-icon>{{icons[t.icon]}}</v-icon>
                                </div>
                                <div class="text-center">{{t.name}}</div>
                            </v-card-text>
                        </v-card>
                    </v-col>
                </v-row>
            </v-container>
        </v-card>
        <router-view></router-view>
    </v-main>
</template>

<script>
  const PATH = '/customers' //im lazy and hate writing `"organi....
  import {
    mapState,
    mapActions
  } from 'vuex'
  export default {
    name: "Index",
    data() {
      return {
        menu: true,
        tiles:[
          {to: PATH+'/list', icon: 'customer', name: 'List Customers'},
          {to: PATH+'/search', icon: 'search', name: 'Search + Create'}
        ],
        activating:false,
      }
    },
    computed:{
      ...mapState(['org','icons']),
      count(){
        return 12/this.tiles.length
      }
    },
    mounted() {
    },
    methods: {
      ...mapActions(['get','post','putAppOrg'])
    }
  }
</script>

<style scoped>

</style>